/**
 * Timezone of current user in the browser
 */
export const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const ISO8601Format = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const ISO8601FormatWithMilliSecond = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
